import * as React from 'react'
import { RouteComponentProps } from "react-router"
import PlayerLoader from "./PlayerLoader"

type Props = RouteComponentProps<{playerPath: string}>

export const PlayerIdRoute: React.FunctionComponent<Props> = ({ match: { params} }) => <PlayerLoader playerPath={params.playerPath} />